import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";

const ProfilePage = lazy(() => import("./pages/ProfilePage").then(module => ({ default: module.ProfilePage })));

function ProfileRoute() {
  const { storeSlug = "" } = useParams();
  return <ProfilePage storeSlug={storeSlug} />;
}

export const profileRoutes: RouteObject[] = [
  {
    path: "profile",
    element: <RouteSuspense><ProfileRoute /></RouteSuspense>,
  },
];
